import { RichTextReadOnly } from 'mui-tiptap';
import { richTextExtensions } from './inputs/richTextExtensions';

// Tiptap gives every editor role="textbox", read-only ones included, which
// screen readers announce as an edit field; this is plain content.
const editorProps = { attributes: { role: 'none' } };

/** Read-only rendering of HTML written with RichTextEditorField. */
export const RichTextContent = ({
  html,
  lang,
}: {
  html: string;
  lang?: string;
}) => (
  <div lang={lang}>
    <RichTextReadOnly
      content={html}
      extensions={richTextExtensions}
      editorProps={editorProps}
    />
  </div>
);
